import { useEffect, useRef } from "react";

/**
 * The hook that tracks if user clicked outside provided element ref
 *
 * @param callback - Callback to execute, when user clicked outside of referenced element.
 * @param shouldInitializeEvents - boolean, default=true.
 *        For conditional initialization, not right away on first render
 *        Useful when elements are added to DOM later, and we don't want click events.
 */
function useClickedOutside(callback: CallableFunction, shouldInitializeEvents = true) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!shouldInitializeEvents) {
      return;
    }

    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      console.log("Triggered click listener!");
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [shouldInitializeEvents, ref]);

  return ref;
}

export { useClickedOutside };
